var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppNavbar',[_c('AppContainer',[_c('AppBrand'),_c('b-navbar-toggle',{attrs:{"target":"nav-collapse"}}),_c('AppNavCollapse',[_c('AppNavbarNav')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }